import type { Handler } from "@phosphor/utils";
import { World } from "#scripts/vmc/WorldState.ts";

export class CKeydownHandler extends World.Component("keydownHandler")<
  CKeydownHandler,
  {
    handler: Handler<KeyboardEvent>;
  }
>() {}
